/* eslint-disable no-multi-spaces */
export default class {
  constructor (canvas) {
    this.canvas = canvas
    this.ctx = canvas.getContext('2d')
    this.sharpStrength = {
      'soft': [-0.25, 4],
      'medium': [-0.5, 6],
      'hard': [-1, 10]
    }
  }

  static getOrientation (buffer) {
    const dv = new DataView(buffer)
    if (dv.getUint16(2) !== 65505) {
      return 0
    }
    const littleEndian = dv.getUint8(12) === 73
    const count = dv.getUint16(20, littleEndian)
    for (let i = 0; i < count; i++) {
      const start = 22 + i * 12
      const tag = dv.getUint16(start, littleEndian)
      if (tag === 274) {
        const value = dv.getUint16(start + 8, littleEndian)
        return value
      }
    }
    return 0
  }

  static arrayBufferToDataURL (arrBuf) {
    const blob = new Blob([arrBuf], { type: 'image/jpeg' })
    return window.URL.createObjectURL(blob)
  }

  drawPic (img, magnification, orientation) {
    const canvas = this.canvas
    const ctx = this.ctx
    const width = img.width / magnification
    const height = img.height / magnification

    if ([5, 6, 7, 8].indexOf(orientation) > -1) {
      canvas.width = height
      canvas.height = width
    } else {
      canvas.width = width
      canvas.height = height
    }

    switch (orientation) {
      case 4: ctx.transform(-1, 0, 0, 1, width, 0); break
      case 3: ctx.transform(-1, 0, 0, -1, width, height); break
      case 2: ctx.transform(1, 0, 0, -1, 0, height); break
      case 5: ctx.transform(0, 1, 1, 0, 0, 0); break
      case 6: ctx.transform(0, 1, -1, 0, height, 0); break
      case 7: ctx.transform(0, -1, -1, 0, height, width); break
      case 8: ctx.transform(0, -1, 1, 0, 0, width); break
    }

    if ([5, 6, 7, 8].indexOf(orientation) > -1) {
      ctx.transform(width / height, 0, 0, height / width, 0, 0)
    }
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
  }

  reverse (data) {
    for (let i = 0; i < data.length; i += 4) {
      data[i]     = 255 - data[i]
      data[i + 1] = 255 - data[i + 1]
      data[i + 2] = 255 - data[i + 2]
    }
  }

  sharp (strength, canvas, data) {
    const _data = data.slice()
    const sub = this.sharpStrength[strength][0]
    const main = this.sharpStrength[strength][1]

    const sharpedColor = (color, i) => {
      /*
      const prevLine = i - (canvas.width * 4)
      const nextLine = i + (canvas.width * 4)
      const sumPrevLineColor = (_data[prevLine-4+color] * sub)  +  (_data[prevLine+color] * sub )  +  (_data[prevLine+4+color] * sub)
      const sumCurrLineColor = (_data[i       -4+color] * sub)  +  (_data[i       +color] * main)  +  (_data[i       +4+color] * sub)
      const sumNextLineColor = (_data[nextLine-4+color] * sub)  +  (_data[nextLine+color] * sub )  +  (_data[nextLine+4+color] * sub)
      return (sumPrevLineColor + sumCurrLineColor + sumNextLineColor) / 2
      */

      const prevLine = i - (canvas.width * 4) + color
      const currLine = i + color
      const nextLine = i + (canvas.width * 4) + color
      return (
        (
          _data[prevLine - 4] + _data[prevLine] + _data[prevLine + 4] +
          _data[currLine - 4]                   + _data[currLine + 4] +
          _data[nextLine - 4] + _data[nextLine] + _data[nextLine + 4]
        ) * sub +
        _data[currLine] * main
      ) / 2
    }

    const widthx4 = canvas.width * 4
    const widthx4and300 = widthx4 + 300
    // 2行目〜n-1行目
    for (let i = widthx4; i < data.length - widthx4; i += 4) {
      // 2列目〜n-1列目
      if (i % widthx4 === 0 || i % widthx4and300 === 0) {
        // nop
      } else {
        data[i]     = sharpedColor(0, i)
        data[i + 1] = sharpedColor(1, i)
        data[i + 2] = sharpedColor(2, i)
      }
    }
    return data
  }

  filter (filter, params) {
    const canvas = this.canvas
    const ctx = this.ctx
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
    const data = imageData.data

    const stime = new Date()
    if (filter === 'sharp') {
      this.sharp(params, canvas, data)
    }
    if (filter === 'reverse') {
      this.reverse(data)
    }

    const etime = new Date()
    console.log('filter time', etime.getTime() - stime.getTime())
    ctx.putImageData(imageData, 0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/lib/picpro.js